@use "styles" as *;

$block: me-teaser;

.#{$block} {
  border-bottom: 1px solid $color-gray-200;
  padding-bottom: space(4);
  display: grid;
  gap: space(4);

  &--normal {
    grid:
      "image" auto
      "header" 1fr;

    @include media-breakpoint-down(sm) {
      grid:
        "image header"
        / $teaser-image-width 1fr;

      .me-image .me-image__author {
        align-self: stretch;
      }
    }
  }

  &--lead {
    grid:
      "image"
      "header";

    .#{$block}__icons {
      gap: space(2);
      padding: space(2);
    }

    @include media-breakpoint-up(md) {
      position: relative;
      border-bottom: none;
      padding-bottom: 0;
      gap: 0;

      --me-line-clamp-max-lines: 4;

      .#{$block}__image {
        width: $teaser-lead-image-width;
      }

      .#{$block}__header {
        position: absolute;
        margin-top: space(10);
        right: 0;
        box-shadow: $box-shadow;
        border-radius: $border-radius;
        padding: space(5);
        min-width: $teaser-lead-content-min-width;
        max-width: $teaser-lead-content-max-width;
        background-color: $color-background;
      }
    }
  }

  &__image {
    grid-area: image;
    position: relative;

    &-link {
      display: block;
    }
  }

  &__icon-wrapper {
    grid-area: image;
  }

  &__icons {
    display: inline-flex;
    flex-direction: column;
    gap: space(1);
    padding: space(1);
    @include remove-first-and-last-child-margins;
  }

  &__social-icons:empty {
    display: none;
  }

  &__body:empty {
    display: none;
  }

  &__header {
    display: flex;
    flex-direction: column;
    gap: space(4);
  }

  &__text {
    grid-area: text;
    @include remove-first-and-last-child-margins;
  }

  &__details {
    grid-area: details;
    color: $color-gray-400;

    &:empty {
      display: none;
    }
  }

  &--card {
    grid:
      "image"
      "header";
    gap: space(3);
    padding-bottom: space(3);
    border-radius: $border-radius;
    border: none;
    box-shadow: $box-shadow-teaser-card;
    overflow: hidden;
    background-color: $color-background-contrast;

    & .#{$block}__header {
      padding: 0 $me-teaser-card-padding-horizontal;
    }
  }

  &--read {
    opacity: $me-teaser-read-opacity;
    filter: $me-teaser-read-filter;
  }

  &--feed {
    grid:
      "header" auto
      "image" auto
      "icons" auto
      "body" auto;
    gap: space(3);

    & .#{$block}__header {
      gap: space(1);
    }

    & .#{$block}__body {
      grid-area: body;
    }

    & .#{$block}__icon-wrapper {
      grid-area: icons;
    }

    & .#{$block}__icons {
      display: flex;
      flex-direction: row;
      gap: space(4);
      padding: space(1);
      justify-content: space-between;
      @include remove-first-and-last-child-margins;

      & .#{$block}__social-icons {
        display: flex;
        gap: space(4);
        @include remove-first-and-last-child-margins;
      }
    }
  }
}

.me-slider .#{$block}--normal {
    grid:
      "image" auto
      "header" 1fr;

    .me-image .me-image__author {
      align-self: flex-end;
    }
}

.fcms {
  .#{$block}.read {
    @extend .#{$block}--read;
  }
}
